import React from 'react';
import { createUseStyles } from 'react-jss';
import created from './images/ApplicationSent.svg';
import application from './images/ApplicationStage.svg';
import responses from './images/ResponseStage.svg';
import approved from './images/Approved.svg';
import renewalApproved from './images/Approved.svg';
import renewalStart from './images/ApplicationSent.svg';

const useStyles = createUseStyles(() => ({
  image: {}
}));

export type Status =
  | 'application'
  | 'responses'
  | 'approved'
  | 'created'
  | 'renewalStart'
  | 'renewalApproved'
  | 'manualVerification';

type Props = {
  status: Status;
};

// created -> application -> responses -> approved

export default function CheckStatus({ status }: Props) {
  const classes = useStyles();

  const images = {
    application,
    responses,
    approved,
    created,
    renewalApproved,
    renewalStart
  };

  return (
    <div>
      <img src={images[status]} className={classes.image} />
    </div>
  );
}
